import { IPublicClientApplication } from "@azure/msal-browser"
import { getToken } from "Components/Functions"
import { api } from "./apiConfig"

// In-memory cache for bank holidays
let cachedBankHolidays: string[] | null = null;
let cacheTimestamp: number | null = null;
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const BankHolidaysAPI = {
    get: async function () {
        // Check if cache is valid
        const now = Date.now();
        if (cachedBankHolidays && cacheTimestamp && (now - cacheTimestamp) < CACHE_DURATION) {
            console.log("Returning cached bank holidays");
            return cachedBankHolidays;
        }

        // Fetch fresh data
        console.log("Fetching fresh bank holidays from API");
        const apiCall = await api();
        const response = await apiCall.request({
            url: "https://www.gov.uk/bank-holidays.json",
            method: "GET",
        })
        const datesList: string[] = [];
        response.data['england-and-wales']['events'].forEach((bh: any) => {
            datesList.push(bh.date)
        });
        
        // Update cache
        cachedBankHolidays = datesList;
        cacheTimestamp = now;
        
        return datesList;
    }
}

export const MonthDetailsAPI = {
    get: async function (instance: IPublicClientApplication, vehicleId:number, year:number, month: number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Calendar/GetMonthDetails?vehicle_id=${vehicleId}&year=${year}&month=${month}`,
            method: "GET",
            headers: { Authorization: header }
        })
        return response.data
    }
}